var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPremium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m408 393h-304c-6.798 0-13.251-8.432-15-15l-48.495-190.14c-1.481-5.56.349-11.476 4.708-15.229 4.36-3.754 10.482-4.681 15.759-2.392l116.933 50.762 65.232-108.72c2.712-4.516 7.594-7.281 12.863-7.281s10.151 2.765 12.862 7.282l65.232 108.72 116.934-50.762c5.279-2.29 11.399-1.361 15.759 2.392 4.359 3.753 6.189 9.669 4.709 15.229l-48.496 190.139c-1.75 6.568-8.202 15-15 15z",
    fill: "#ffcb49"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m466.786 172.632c-4.359-3.753-10.479-4.682-15.759-2.392l-116.934 50.762-65.232-108.72c-2.71-4.517-7.592-7.282-12.861-7.282v288h152c6.798 0 13.25-8.432 15-15l48.495-190.14c1.481-5.559-.349-11.475-4.709-15.228z",
    fill: "#ffad09"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m176 321c-8.284 0-15 6.716-15 15v42c0 8.284 6.716 15 15 15s15-6.716 15-15v-42c0-8.284-6.716-15-15-15z",
    fill: "#ffad09"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m336 321c-8.284 0-15 6.716-15 15v42c0 8.284 6.716 15 15 15s15-6.716 15-15v-42c0-8.284-6.716-15-15-15z",
    fill: "#ff8c00"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 297c-8.284 0-15 6.716-15 15v66c0 8.284 6.716 15 15 15s15-6.716 15-15v-66c0-8.284-6.716-15-15-15z",
    fill: "#ffad09"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 297v96c8.284 0 15-6.716 15-15v-66c0-8.284-6.716-15-15-15z",
    fill: "#ff8c00"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m89 378v54c0 8.284 6.716 15 15 15h304c8.284 0 15-6.716 15-15v-54z",
    fill: "#ffeb7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 378v69h152c8.284 0 15-6.716 15-15v-54z",
    fill: "#ffcb49"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 174,
    fill: "#ffeb7a",
    r: 45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467,
    cy: 174,
    fill: "#ffcb49",
    r: 45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 110,
    fill: "#ffeb7a",
    r: 45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 65v90c24.813 0 45-20.186 45-45s-20.186-45-45-45z",
    fill: "#ffcb49"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.542179551489ee1d4025b54aa500d816.svg";
export { ForwardRef as ReactComponent };